import { createAction, createReducer } from '@reduxjs/toolkit';

export interface IProductPermission {
  authorizedProducts: any[];
}

const INITIAL_STATE: IProductPermission = {
  authorizedProducts: [],
};

export const getProfileProductsAuthAction = createAction<Array<Object>>(
  '@productsPage/GET_PROFILE_PRODUCTS_AUTH'
);

const profileAuthReducer = createReducer(INITIAL_STATE, {
  [getProfileProductsAuthAction.type]: (state, action) => ({
    ...state,
    authorizedProducts: action.payload,
  }),
});

export default profileAuthReducer;
